import {collection, getCountFromServer, query,} from 'firebase/firestore'
import {fire} from "../../../fire";

export const contarColeccion = ({coleccion}) => {
    // 0 es enero


    let q = query(collection(fire, coleccion))


    return new Promise(resolve => {
        getCountFromServer(q).then((dox) => {
            return resolve({res: true, data: dox.data().count})
        }).catch((err) => {
            return resolve({res: false, data: 0})
        })
    })


}